import { Employee } from 'modules/core/hooks/useCurrentSession'
import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'
import hasFeature from 'modules/core/lib/hasFeature'
import users from 'modules/core/store/collections/users'

import { isManager } from 'modules/employees/lib/utils'

import { hasEngagementInsightsModule } from './hasEngagementInsightsModule'
import { hasEnpsModule } from './hasEnpsModule'
import { hasSurveysModule } from './hasSurveysModule'

export interface EngagementAuthProps {
  seeEnps: boolean
  seeInsights: boolean
  seeSurveys: boolean
  launchSurveys: boolean
  seeEngagement: boolean
  manageSurveys: boolean
}

interface EngagementAuthParams {
  moduleAvailabilities: ModuleAvailabilityType[]
  currentEmployee: Employee
}

// TODO: This function is terrible. It is coupled to many bad patterns (global collections, feature flags, module availability, etc.)
//       In most of the places you only need one of these 6 flags and you are paying the full price just to get them all.
//       We should refactor this to be a single flag per page/feature.
export default function engagementAuthorization({
  moduleAvailabilities,
  currentEmployee,
}: EngagementAuthParams): EngagementAuthProps {
  const manageSurveys = users.current.policy.can('surveys.v2ManageSurveys')
  const hasSeeInsightsPermission = manageSurveys //TODO: replace this with see insights policy check when available
  const seeSurveys =
    hasSurveysModule(moduleAvailabilities) &&
    (manageSurveys || users.current.policy.can('apiCore.accessSurveysSeeForms'))
  const seeEnps =
    hasEnpsModule(moduleAvailabilities) && users.current.policy.can('apiCore.accessEnpsSeeForms')

  const surveysAndEnpsAllowsInsights = hasFeature('dev_packaging_paywalls')
    ? hasSurveysModule(moduleAvailabilities) && hasEnpsModule(moduleAvailabilities)
    : true
  const seeInsights =
    hasEngagementInsightsModule(moduleAvailabilities) &&
    ((currentEmployee && isManager(currentEmployee)) || hasSeeInsightsPermission) &&
    surveysAndEnpsAllowsInsights

  const launchSurveys = hasEngagementInsightsModule(moduleAvailabilities) && manageSurveys
  const seeEngagement = seeSurveys || seeEnps || seeInsights

  return {
    seeEnps,
    seeInsights,
    seeSurveys,
    seeEngagement,
    manageSurveys,
    launchSurveys,
  }
}
